import { all, call, put, takeLatest } from "redux-saga/effects";
import { AxiosCall } from "../../../utils/axios";
import * as actions from "./actions";

function* fetchBrevoContacts() {
    try {
        const result = yield call(AxiosCall, '/brevo/get_all_contacts/');
        yield put(actions.fetchBrevoContactsSuccess(result.data.results));
    } catch (e) {
        yield put(actions.fetchBrevoContactsFailure(e));
    }
}

export default function* rootSaga() {
    yield all([
        // watchers contacts
        takeLatest(actions.FETCH_BREVO_CONTACTS.REQUEST, fetchBrevoContacts),
    ])
}